exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-layout-register > h3[data-v-30b8895d] {\n  font-size: 16px;\n  margin-bottom: 20px;\n}\n.user-layout-register .getCaptcha[data-v-30b8895d] {\n  display: block;\n  width: 100%;\n  height: 40px;\n}\n.user-layout-register .register-button[data-v-30b8895d] {\n  width: 50%;\n}\n.user-layout-register .login[data-v-30b8895d] {\n  float: right;\n  line-height: 40px;\n}\n", ""]);

// exports
